<template>
  <div>
    <div
      v-for="(option, index) in options"
      :key="index"
      :class="$style.option"
      v-test="'base-radio-option'"
      @click="onClick(option)"
    >
      <div :class="$style.inner">
        <BaseRoundCheckbox
          v-if="variant === 'check'"
          :isActive="modelValue === option.value"
        />
        <div v-else :class="$style.btn" :style="btnOuterStyle">
          <div
            v-show="modelValue === option.value"
            :class="$style.checked"
            :style="btnInnerStyle"
          />
        </div>
        <div :class="$style.label">
          {{ option.label }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseRoundCheckbox from '@/components/BaseRoundCheckbox.vue';
import widgetSettings from '@/widget-settings';
export default {
  components: {
    BaseRoundCheckbox
  },
  props: {
    modelValue: {
      type: [String, Number, Boolean],
      required: false
    },
    variant: {
      type: String,
      default: 'round'
    },
    options: {
      type: Array,
      required: true,
      validator: (value) =>
        !value.find((item) => !item.label || item.value === undefined)
    }
  },
  computed: {
    btnOuterStyle() {
      return {
        'border-color': `${widgetSettings.color}`
      };
    },
    btnInnerStyle() {
      return {
        'background-color': `${widgetSettings.color}`
      };
    }
  },
  methods: {
    onClick(selected) {
      this.$emit('update:modelValue', selected.value);
    }
  }
};
</script>

<style lang="scss" module>
.inner {
  display: flex;
  cursor: default;
}

.option {
  margin: $spacing 0;
}

.btn {
  min-width: $spacing * 1.5;
  height: $spacing * 1.5;
  border-radius: 50%;
  border: 2px solid $color-border-input;
  position: relative;
}

.checked {
  display: flex;
  position: absolute;
  border-radius: 50%;
  left: 3px;
  top: 3px;
  width: calc(100% - 6px);
  height: calc(100% - 6px);
  box-shadow: inset 0 2px 0 rgba(0, 0, 0, 0.06);
}

.label {
  display: flex;
  align-items: center;
  margin-left: $spacing * 0.5;
}
</style>
